import React, { useState } from "react";

import Box from "@material-ui/core/Box";
import Rating from "@material-ui/core/Rating";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import { TextareaAutosize } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { PostAdd } from "@material-ui/icons";

import { useDispatch } from "react-redux";
import { newDish } from "../../store/dishes/actions";

export default function NewDishForm(props) {
  const dispatch = useDispatch();
  const [overallRate, setOverallRate] = useState();
  const [sizeRate, setSizeRate] = useState();
  const [benefitRate, setBenefitRate] = useState();
  const [presentationRate, setPresentationRate] = useState();
  const [tasteRate, setTasteRate] = useState();
  const [name, setName] = useState();
  const [description, setDescription] = useState();

  function sendReview(event) {
    event.preventDefault();
    const restaurantId = props.selectedId;

    dispatch(
      newDish(
        name,
        description,
        overallRate,
        sizeRate,
        presentationRate,
        tasteRate,
        benefitRate,
        restaurantId
      )
    );
  }

  return (
    <Box
      sx={{
        "& > legend": { mt: 2 },
      }}
    >
      <label for="fname">Dish name:</label>
      <br></br>
      <input
        // required
        // id="standard-basic"
        // label="Standard"
        // variant="standard"
        // size="small"
        style={{ font: "10px", color: "black" }}
        value={name}
        onChange={(event) => {
          setName(event.target.value);
        }}
      ></input>

      {/* <TextField
        id="standard-basic"
        label="Description"
        defaultValue="Description of the new dish"
        variant="standard"
        value={description}
      /> */}

      <Typography component="legend">Overall</Typography>
      <Rating
        name="simple-controlled"
        required
        value={overallRate}
        onChange={(event, newValue) => {
          setOverallRate(parseInt(newValue));
        }}
      />
      <Typography component="legend">Cost-benefit</Typography>
      <Rating
        name="simple-controlled"
        value={benefitRate}
        onChange={(event, newValue) => {
          setBenefitRate(parseInt(newValue));
        }}
      />
      <Typography component="legend">Taste</Typography>
      <Rating
        name="simple-controlled"
        value={tasteRate}
        onChange={(event, newValue) => {
          setTasteRate(parseInt(newValue));
        }}
      />
      <Typography component="legend">Presentation</Typography>
      <Rating
        name="simple-controlled"
        value={presentationRate}
        onChange={(event, newValue) => {
          setPresentationRate(parseInt(newValue));
        }}
      />
      <p></p>
      <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
        <InputLabel id="demo-simple-select-standard-label">Size</InputLabel>
        <Select
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          value={sizeRate}
          onChange={(event) => {
            setSizeRate(parseInt(event.target.value));
          }}
          label="size"
        >
          <MenuItem value={1}>Tiny</MenuItem>
          <MenuItem value={2}>Small</MenuItem>
          <MenuItem value={3}>Medium</MenuItem>
          <MenuItem value={4}>Big</MenuItem>
          <MenuItem value={5}>Huge</MenuItem>
        </Select>
      </FormControl>
      <p></p>
      <TextareaAutosize
        maxRows={4}
        aria-label="maximum height"
        label="Description"
        placeholder="Maximum 4 rows"
        defaultValue="Description of the dish"
        style={{ width: 320 }}
        value={description}
        onChange={(event) => {
          setDescription(event.target.value);
        }}
      />
      <p></p>
      <Button
        sx={{ color: "#000d30" }}
        variant="outlined"
        startIcon={<PostAdd />}
        onClick={sendReview}
      >
        Send new dish
      </Button>
    </Box>
  );
}
